import React, { useState, useEffect } from 'react';
import { isMobile, isSafari } from 'react-device-detect';
import axios from 'axios';
import { VideoProps } from './Video.interface';

export function Video({ video }: VideoProps) {
    const [videoBlobUrl, setVideoBlobUrl] = useState<string | null>(null);
    const getVideoBlob = (videoUrl: string) => {
        axios.get(videoUrl, { responseType: 'arraybuffer'}).then((res) => {
            let blob = new Blob([res.data], { type: 'video/mp4' });
            let url = URL.createObjectURL(blob);
            setVideoBlobUrl(url);
        })
    }
    useEffect(() => {
        if (isSafari && video) {
            getVideoBlob(video);
        }
    }, [])
    return (
        <div>
            <video 
                width={isMobile ? '100%' : '728px'} 
                height={isMobile ? 'auto' : '410px'} 
                autoPlay 
                loop
                controls
                muted
                src={(isSafari && videoBlobUrl) ? videoBlobUrl : video}>
            </video>
        </div>
    )
}
